import { DsData } from './ds-data';

export class DsDevice {
  sideNumber: string;
  machineId: string;
  hostname: string;
  lastLoginAt: Date;
  wifi: boolean;
  gsm: boolean;
  address: string;
  current: boolean;
  syncTimestamp: Date;
  data: DsData[];

  static getName(): string {
    return 'DS_DEVICES';
  }
}
